<template>            
<svg width="18" height="18" viewBox="0 0 18 18" fill="none"
      xmlns="http://www.w3.org/2000/svg">
  <path
      d="M8.99998 14.6795L14.6794 9.00002L8.99998 3.32056L8.23398 4.09458L12.5978 8.45837H3.32053V9.54166H12.5978L8.23398 13.9055L8.99998 14.6795Z"
      fill="#888888"/>
</svg>
</template>